import { generatePath } from 'react-router-dom'

class RouteError extends Error {
    constructor(msg) {
        super('RouteError: ' + msg)
    }
}

export const routeConfig = [
    {
        path: '/mfa/verify/success',
        title: 'Mfa verify success',
        component: './MfaVerifySuccess',
        name: 'mfa-verify-success',
        paramsExistence: data => {
            return paramsExist(data)
        },
    },
    {
        path: '/mfa/verify/retry',
        title: 'Mfa verify retry',
        component: './MfaVerifyRetry',
        name: 'mfa-verify-retry',
        paramsExistence: data => {
            return paramsExist(data)
        },
    },
    {
        path: '/mfa/verify',
        title: 'Mfa verify',
        component: './MfaVerify',
        name: 'mfa-verify',
        paramsExistence: data => {
            return paramsExist(data)
        },
    },
    {
        path: '/mfa/faq',
        title: 'Mfa faq',
        component: './MfaFaq',
        name: 'mfa-faq',
    },
    {
        path: '/mfa/registration',
        title: 'Mfa registration',
        component: './MfaRegistration',
        name: 'mfa-registration',
        paramsExistence: data => {
            return paramsExist(data)
        },
    },
    {
        path: '/mfa/explanation',
        title: 'Mfa explanation',
        component: './MfaExplanation',
        name: 'mfa-explanation',
    },
    {
        path: '/mfa/why',
        title: 'Why mfa',
        component: './MfaWhy',
        name: 'mfa-why',
    },
    {
        path: '/',
        title: 'Mfa startpage',
        component: './MfaStart',
        name: 'mfa-start',
        paramsExistence: data => {
            return paramsExist(data)
        },
    },
]

export const reverse = (name, params = {}, queryParams = {}) => {
    const routes = routeConfig.filter(route => route.name === name)
    if (routes.length === 0) {
        throw new RouteError(`No matches found in routeConfig for ${name}`)
    } else if (routes.length > 1) {
        throw new RouteError(
            `Multiple matches found in routeConfig for ${name}: ${routes
                .map(r => r.path)
                .join(', ')}`
        )
    }
    // this will raise a TypeError if params provided do not match the path
    const path = generatePath(routes[0].path, params)
    if (Object.entries(queryParams).length) {
        const searchParams = new URLSearchParams(queryParams)

        return `${path}?${searchParams.toString()}`
    }
    return path
}

const paramsExist = data => {
    return (
        data.signature &&
        data.username &&
        data.organization_id &&
        data.first_name &&
        data.sessionToken
    )
}
